import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, message } from 'antd';
import axiosInstance from '../../../axiosInstance';

const Categories = () => {
    const [categories, setCategories] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/categories');
            if (response.data.categories) {
                setCategories(response.data.categories);
            } else {
                message.error('Failed to fetch categories.');
                setCategories([]);
            }
        } catch (error) {
            console.error(error);
            message.error('Failed to fetch categories.');
            setCategories([]);
        } finally {
            setLoading(false);
        }
    };

    const showModal = (category = null) => {
        if (category) {
            setEditingCategory(category);
            form.setFieldsValue(category);
        } else {
            setEditingCategory(null);
            form.resetFields();
        }
        setIsModalVisible(true);
    };

    const handleOk = async (values) => {
        try {
            let response;
            if (editingCategory) {
                response = await axiosInstance.put(`/categories/${editingCategory.id}`, values);
                message.success('Category updated successfully');
            } else {
                response = await axiosInstance.post('/categories', values);
                message.success('Category added successfully');
            }
            fetchCategories();
            setIsModalVisible(false);
            form.resetFields();
        } catch (error) {
            message.error('Failed to save category.');
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields();
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, category) => (
                <Button onClick={() => showModal(category)}>Edit</Button>
            ),
        },
    ];

    return (
        <div>
            <div style={{ textAlign: 'right', marginBottom: 16 }}>
                <Button type="primary" onClick={() => showModal()}>
                    Add Category
                </Button>
            </div>

            <Table
                columns={columns}
                dataSource={Array.isArray(categories) ? categories : []}
                rowKey="id"
                pagination={{ pageSize: 25 }}
                scroll={{ x: 'max-content' }}
                loading={loading}
            />

            <Modal
                title={editingCategory ? 'Edit Category' : 'Add New Category'}
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={handleCancel}
                okText={editingCategory ? 'Update' : 'Add'}
                cancelText="Cancel"
                destroyOnClose
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleOk}
                >
                    <Form.Item
                        name="name"
                        label="Name"
                        rules={[{ required: true, message: 'Please input the category name!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default Categories;
